import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/5-reasons-to-see-a-tax-professional",
    component: _cffe3db6,
    name: "5-reasons-to-see-a-tax-professional"
  }, {
    path: "/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/6-questions-to-ask-a-financial-professional",
    component: _cffe3db6,
    name: "6-questions-to-ask-a-financial-professional"
  }, {
    path: "/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/child-education-cost",
    component: _cffe3db6,
    name: "child-education-cost"
  }, {
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/financial-basics-for-your-high-school-graduate",
    component: _cffe3db6,
    name: "financial-basics-for-your-high-school-graduate"
  }, {
    path: "/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/how-to-get-the-most-out-of-your-extra-cash",
    component: _cffe3db6,
    name: "how-to-get-the-most-out-of-your-extra-cash"
  }, {
    path: "/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/preparing-for-retirement-over-the-decades",
    component: _cffe3db6,
    name: "preparing-for-retirement-over-the-decades"
  }, {
    path: "/retirement-plans-for-small-businesses",
    component: _cffe3db6,
    name: "retirement-plans-for-small-businesses"
  }, {
    path: "/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/simple-ways-to-provide-financial-wellness-to-employees",
    component: _cffe3db6,
    name: "simple-ways-to-provide-financial-wellness-to-employees"
  }, {
    path: "/starting-a-family-the-total-cost-of-a-baby",
    component: _cffe3db6,
    name: "starting-a-family-the-total-cost-of-a-baby"
  }, {
    path: "/why-the-human-element-matters-in-financial-guidance",
    component: _cffe3db6,
    name: "why-the-human-element-matters-in-financial-guidance"
  }, {
    path: "/about-us/my-background",
    component: _cffe3db6,
    name: "my-background"
  }, {
    path: "/products-and-services/advanced-planning-resources",
    component: _cffe3db6,
    name: "advanced-planning-resources"
  }, {
    path: "/products-and-services/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/products-and-services/for-professional-advisors",
    component: _cffe3db6,
    name: "for-professional-advisors"
  }, {
    path: "/products-and-services/our-services",
    component: _cffe3db6,
    name: "our-services"
  }, {
    path: "/products-and-services/products",
    component: _cffe3db6,
    name: "products"
  }, {
    path: "/resources/articles",
    component: _cffe3db6,
    name: "articles"
  }, {
    path: "/resources/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/resources/life-stages",
    component: _cffe3db6,
    name: "life-stages"
  }, {
    path: "/resources/tax-resources",
    component: _cffe3db6,
    name: "tax-resources"
  }, {
    path: "/resources/videos",
    component: _cffe3db6,
    name: "videos"
  }, {
    path: "/resources/articles/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/resources/articles/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/resources/articles/5-reasons-to-see-a-tax-professional",
    component: _cffe3db6,
    name: "5-reasons-to-see-a-tax-professional"
  }, {
    path: "/resources/articles/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/resources/articles/6-questions-to-ask-a-financial-professional",
    component: _cffe3db6,
    name: "6-questions-to-ask-a-financial-professional"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/child-education-cost",
    component: _cffe3db6,
    name: "child-education-cost"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/financial-basics-for-your-high-school-graduate",
    component: _cffe3db6,
    name: "financial-basics-for-your-high-school-graduate"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/how-to-get-the-most-out-of-your-extra-cash",
    component: _cffe3db6,
    name: "how-to-get-the-most-out-of-your-extra-cash"
  }, {
    path: "/resources/articles/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/resources/articles/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/resources/articles/preparing-for-retirement-over-the-decades",
    component: _cffe3db6,
    name: "preparing-for-retirement-over-the-decades"
  }, {
    path: "/resources/articles/retirement-plans-for-small-businesses",
    component: _cffe3db6,
    name: "retirement-plans-for-small-businesses"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/simple-ways-to-provide-financial-wellness-to-employees",
    component: _cffe3db6,
    name: "simple-ways-to-provide-financial-wellness-to-employees"
  }, {
    path: "/resources/articles/starting-a-family-the-total-cost-of-a-baby",
    component: _cffe3db6,
    name: "starting-a-family-the-total-cost-of-a-baby"
  }, {
    path: "/resources/articles/why-the-human-element-matters-in-financial-guidance",
    component: _cffe3db6,
    name: "why-the-human-element-matters-in-financial-guidance"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
